
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';

const TOOL_STYLE = mergeStyles({
    backgroundColor: 'rgb(50, 52, 54, 1)',
    borderRadius: '0px',
});

const TOOL_STYLE_UP = mergeStyles({
    backgroundColor: 'rgb(50, 52, 54, 1)',
    borderRadius: '1em 1em 0em 0em',
});

const TOOL_STYLE_DOWN = mergeStyles({
    backgroundColor: 'rgb(50, 52, 54, 1)',
    borderRadius: '0em 0em 1em 1em',
});

const getIcon = (name) => {
    return {
        iconName: name,
    };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    TOOL_STYLE,
    TOOL_STYLE_UP,
    TOOL_STYLE_DOWN,
    getIcon
}
